import React from 'react';
import { Grid, MenuItem, Select } from '@mui/material';
import { exchangeRates, special_country_code_currency_map, USER_REFERRED_CURRENCY } from 'src/utils/const';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import { useSelector } from 'react-redux';

const CurrencyChangeMenu = ({
  currency,
  setCurrency,
  fullWidth,
  darkTheme,
  renderAsText,
  handleDefaultCurrencyOnly
}: {
  currency: string;
  setCurrency;
  fullWidth?: boolean;
  darkTheme?: boolean;
  renderAsText?: boolean;
  handleDefaultCurrencyOnly?: boolean;
}) => {
  const changeCurrency = event => {
    setCurrency(event.target.value);
  };
  
  const userCountryCode = useSelector((state: any) => state.dashboard.userCountryCode) || 'US';
  const userLocalCurrency = special_country_code_currency_map[userCountryCode] || 'USD';

  const fullWidthStyle = {
    width: fullWidth ? '100%' : 'auto',
  };

  const darkModeStyle = {
    ...fullWidthStyle,
    '& svg': {
      color: '#fff',
    },
    '& .MuiSelect-select': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fff',
    },
  };

  const sortCurrencyOptions = (currencyArray: string[]) => {
    const highPriorityCurrencyArray: string[] = ['USD', 'EUR', 'GBP', 'AUD', 'CAD'];

    if (highPriorityCurrencyArray.includes(userLocalCurrency)){
      highPriorityCurrencyArray.splice(highPriorityCurrencyArray.indexOf(userLocalCurrency), 1);      
    }
    highPriorityCurrencyArray.unshift(userLocalCurrency);

    const restCurrencies: string[] = [];

    for (const currency of currencyArray){
      if(!highPriorityCurrencyArray.includes(currency)){
        restCurrencies.push(currency);
      }
    }

    restCurrencies.sort();

    return [...highPriorityCurrencyArray, ...restCurrencies];
  }

  const currencyFromLocalStorage = localStorage.getItem(USER_REFERRED_CURRENCY);

  return (
    <>
      <MenuItem
        sx={darkTheme ? darkModeStyle : fullWidthStyle}
        style={renderAsText ? { paddingRight: '5px', paddingLeft: 0, marginRight: '5px' } : {}}
      >
        <Grid container alignItems="center">
          <Grid item xs={12} sx={{ position: 'relative' }}>
            <Select
              labelId="currency-select-label"
              id="currency-select"
              variant="outlined"
              className="notranslate"
              value={
                handleDefaultCurrencyOnly
                  ? currencyFromLocalStorage
                    ? currencyFromLocalStorage
                    : '-'
                  : currency
              }
              onChange={event => {
                changeCurrency(event);
                localStorage.setItem(USER_REFERRED_CURRENCY, event.target.value as string);
              }}
              sx={{
                width: fullWidth ? '100%' : 30,
                height: 40,
                ...(renderAsText && {
                  paddingLeft: 0,
                  paddingRight: '5px',
                  color: COLOR_PRIMARY_2,
                  fontWeight: 'bold',
                  outline: 'none',
                  border: 'none',
                  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '& > *': {
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                  '&': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  },
                }),
              }}
              IconComponent={() =>
                renderAsText ? null : <ExpandMoreRoundedIcon sx={{ pointerEvents: 'none' }} />
              } // Hides the dropdown arrow
            >
              {handleDefaultCurrencyOnly && (
                <MenuItem value="-" disabled>
                  Select your default currency
                </MenuItem>
              )}
              {sortCurrencyOptions(Object.keys(exchangeRates)).map((type, index) => (
                <MenuItem key={index} value={type} className="notranslate">
                  {type}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </MenuItem>
    </>
  );
};

export default CurrencyChangeMenu;
